import React, { useEffect, useState } from "react";
import BpCheckbox from "view/components/CheckBox";
import "./Types.scss";
import apiLibrary from "services/api";
import InputField from "view/components/InputField";
import { useDispatch } from "react-redux";
import { dataPortalFileTypeAction, speciesTypesAction } from "store/filters/reducer.actions";
import { useSelector } from "react-redux";
import { RootState } from "store";
import ellipsize from "ellipsize";
import { filtersInitialState } from "store/filters/initialState";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import { TailSpin } from "react-loader-spinner";
import useCustomBranding from "hooks/useCustomBranding";

export const FileType = () => {
  const { dataPortalFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const [searchString, setSearchString] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [page, setPage] = useState(1);

  const dispatch = useDispatch();

  const [dropDownValues, setDropDownValues] = useState<any[]>([
    {
      id: "jpg",
      label: "JPG",
    },
    {
      id: "png",
      label: "PNG",
    },
    {
      id: "pdf",
      label: "PDF",
    },
    {
      id: "docx",
      label: "DOCX",
    },
    {
      id: "xlsx",
      label: "XLSX",
    },
    {
      id: "pptx",
      label: "PPTX",
    },
    {
      id: "txt",
      label: "TXT",
    },
    {
      id: "csv",
      label: "CSV",
    },
    {
      id: "doc",
      label: "DOC",
    },
    {
      id: "mp3",
      label: "MP3",
    },
    {
      id: "mp4",
      label: "MP4",
    },
    {
      id: "wav",
      label: "WAV",
    },
    {
      id: "avi",
      label: "AVI",
    },
    {
      id: "m4a",
      label: "M4A",
    },
  ]);
  const { primaryColor } = useCustomBranding();

  const handleSelection = (
    e: React.ChangeEvent<HTMLInputElement>,
    selectedValue: any
  ) => {
    dispatch(dataPortalFileTypeAction(selectedValue.id));
  };

  return (
    <div className="bg-bgWhite dark:bg-secondaryLight w-[315px] overflow-hidden shadow-xl rounded-xl flex flex-col justify-start items-start relative border border-lineMid dark:border-lineLight">
      <div className="w-full h-auto min-h-[50px] max-h-[400px] overflow-auto">
        <div className="w-full pl-3 pr-3 mt-2 mb-3 bg-bgWhite dark:bg-secondaryLight"></div>
        <div className="pl-1.5 bg-bgWhite dark:bg-secondaryLight">
          {dropDownValues?.length === 0 && !isLoading && (
            <div className="w-full flex items-center justify-center py-32 text-textMid font-semibold dark:text-inputText">
              No Record Found
            </div>
          )}

          {hasMoreData && isLoading && (
            <div className="flex items-center justify-center w-full loader">
              <TailSpin
                height="30"
                width="30"
                color={primaryColor}
                ariaLabel="tail-spin-loading"
                radius="2"
                wrapperStyle={{}}
                wrapperClass="tailspin-loader"
                visible={true}
              />
            </div>
          )}
          {dropDownValues?.map((dropDown: any, index: any) => (
            <div
              key={index}
              className="flex items-center justify-start w-full px-1 rounded-lg"
            >
              <BpCheckbox
                checked={dataPortalFilter.fileType.value.some((item: any) => item === dropDown.id)}
                label={
                  <div className="flex whitespace-nowrap justify-start items-center flex-grow relative py-0.5">
                    <p className="dark:text-inputText capitalize">
                      {ellipsize(`${dropDown.id}`, 25)}
                    </p>
                  </div>
                }
                labelPlacement="end"
                onChange={(e) => handleSelection(e, dropDown)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
